










































































































import { mixins } from "vue-class-component";
import WeMixin from "@/components/weMixin";
import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";
import api, { apibase, WeAxiosRequestConfig } from "@/components/http/api";
import {
  Form,
  Calendar,
  Field,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  List,
  Button,
  Cell,
  Picker,
  CellGroup,
  SwipeCell,
  ActionSheet,
  Dialog,
  Popup,
  DatetimePicker,
  Image,
  Collapse,
  CollapseItem,
  Divider,
  DropdownMenu,
  DropdownItem,
} from "vant";
import Jssdk, { WxJsapiSignature } from "@/components/wechat/wechatJssdkMixin";
import { Toast, Panel } from "vant";
import { Icon } from "vant";
import { Loading } from "vant";
import { PullRefresh, Grid, GridItem, Card, Tabbar, TabbarItem } from "vant";
import { NavBar } from "vant";
import Axios, { AxiosResponse } from "axios";
import { MerchantRaffleInfo } from "./MerchantApi";
import DemoBlock from "@/components/DemoBlock.vue";
import DemoSection from "@/components/DemoSection.vue";

@Component({
  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Picker.name]: Picker,
    [List.name]: List,
    [Panel.name]: Panel,
    [Calendar.name]: Calendar,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Loading.name]: Loading,
    [Dialog.name]: Loading,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [SwipeCell.name]: SwipeCell,
    [ActionSheet.name]: ActionSheet,
    [Image.name]: Image,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [Card.name]: Card,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [NavBar.name]: NavBar,
    DemoBlock,
    DemoSection,
  },
})
export default class MerchantRaffleQuery extends mixins(WeMixin, Jssdk) {
  private list = [];
  private infoList = [];
  private loadNumUp = 5;
  private loading: boolean = false;
  private finished: boolean = false;
  private pageNum = 0;
  private merchantRaffleInfo: MerchantRaffleInfo = {} as MerchantRaffleInfo;

  protected created() {
    this.initWx().then((wjs: WxJsapiSignature) => {
      this.$wx.config({
        debug: wjs.debug, // wjs.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wjs.appId, // 必填，公众号的唯一标识
        timestamp: wjs.timestamp, // 必填，生成签名的时间戳
        nonceStr: wjs.nonceStr, // 必填，生成签名的随机串
        signature: wjs.signature, // 必填，签名
        jsApiList: ["openLocation"], // 必填，需要使用的JS接口列表
      });
    });
  }

  protected loadList() {
    setTimeout(() => {
      const page = {
        ep: this.loadNumUp,
        sp: ++this.pageNum,
      };
      api
        .post("/weixinmp/xsyx/merchant/getMerchantRaffleList", page, {
          weLoading: true,
        } as WeAxiosRequestConfig)
        .then((response: AxiosResponse) => {
          const ss = response.data;
          if (ss.length != 0) {
            this.infoList = this.infoList.concat(ss);
          }
          if (ss.length == 0) {
            this.finished = true;
          }
          this.loading = false;
        });
    }, 1000);
  }

  protected toNavigation(orgid: any) {
    this.merchantRaffleInfo.orgid = orgid;
    api
      .post(
        "/weixinmp/xsyx/merchant/getMerchantRaffleInfo2",
        this.merchantRaffleInfo
      )
      .then((res: any) => {
        if (res.data.awardingaddress == "没有该地址的经纬度信息") {
          this.$toast(res.data.awardingaddress);
          return;
        }
        if (!this.$wxReady) {
          return;
        }
        this.$wx.openLocation({
          latitude: parseFloat(res.data.lat),
          longitude: parseFloat(res.data.lng),
          name: res.data.awardingaddress,
          scale: 28,
        });
      });
  }
}
